var render = function render(){var _vm=this,_c=_vm._self._c;return _c("transition-group",{tag:"div",staticClass:"toast-container",attrs:{"name":"toast"},on:{"after-enter":_vm.afterEnter}},_vm._l((_vm.$root.toasts),function(toast,k){return _c('div',{key:toast.key,class:`toast ${_vm.toastType(toast.type)}`,attrs:{"data-key":k}},[_vm._v(" "+_vm._s(toast.msg)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }